import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { BiEdit } from "react-icons/bi";
import { TbReportAnalytics } from "react-icons/tb";
import { AiFillEye, AiFillEyeInvisible, AiOutlineReload } from "react-icons/ai";
import { FaLink, FaSpinner, FaTrash } from "react-icons/fa";
import { RiSearchLine } from "react-icons/ri";

import { Popover, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { useLazyQuery, useMutation } from "@apollo/client";

import { setAllForms, setCurrentForm } from "../../redux/actions/forms";
import { GET_FORMS } from "../../GraphQl/Queries";
import { roles } from "../../constants/Roles";
import {
  DELETE_FORM_MUTATION,
  UPDATE_FORM_METADATA_UPDATE_MUTATION,
} from "../../GraphQl/Mutations";
import AntdTable from "../../components/Table/Table";
import Loader from "../../components/Loader";
import "../../styles/forms.css";

import { EmailEncryption, EncodeURL, maskPhoneNumber } from "../../functions";
const ManageForm = () => {
  const [PageSize, setPageSize] = useState(8);
  const [localForms, setLocalForms] = useState([]);
  const state = useSelector((state) => state.allForms);
  const dispatch = useDispatch();

  const [getForms, allForms] = useLazyQuery(GET_FORMS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (res) => {
      setLocalForms(res?.getAllForms);
      dispatch(setAllForms(res?.getAllForms));
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const [currForm, setCurrForm] = useState({
    id: "",
    visibility: "",
    color: "",
  });
  const [updateFormMetadata, updatedMetaData] = useMutation(
    UPDATE_FORM_METADATA_UPDATE_MUTATION,
    {
      variables: {
        updateFormId: currForm?.id,
        updateFormDataInput: {
          formMetadata: {
            visibility: currForm.visibility,
            theme: {
              color: currForm.color,
            },
          },
        },
      },
      onCompleted: (data) => {
        getForms();
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  const [deleteForm, deletedForm] = useMutation(DELETE_FORM_MUTATION, {
    onCompleted: (data) => {
      console.log(data);
      getForms();
    },
    onError: (err) => console.log(err),
  });

  const [data, setData] = useState([]);
  const [userType, setUserType] = useState(() => {
    return localStorage.getItem("shub-roles") !== roles.SURVEYOR
      ? "Surveyor"
      : "Admin";
  });
  // const { currentForm, updateCurrentForm } = useContext(FormContext);
  const [paginateStatus, setPaginateStatus] = useState({
    current: 1,
    pageSize: PageSize,
  });
  const columns = [
    {
      title: "Form Title",
      dataIndex: "formTitle",
      key: "formTitle",
      width: "16.66%",
      fixed: "left",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          <span className='surveyorName'>{record?.formTitle}</span>
          <span
            className='surveyorEmail'
            style={{
              maxWidth: "80px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {record?.description || "Unavailable"}
          </span>
        </div>
      ),
    },
    {
      title: userType,
      dataIndex: userType,
      key: userType,
      width: "16.66%",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          <span className='surveyorName'>
            {userType == "Admin" && record?.adminDetails?.fullName}
            {userType == "Surveyor" && record?.surveyorDetails?.fullName}
          </span>
          <span className='surveyorEmail'>
            {userType == "Admin" && record?.adminDetails?.email}
            {userType == "Surveyor" &&
              EmailEncryption(record?.surveyorDetails?.email)}
          </span>
        </div>
      ),
    },
    {
      title: "Assigned To",
      dataIndex: ["adminDetails", "fullName"],
      key: ["adminDetails", "fullName"],
      width: "5.66%",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          <span className='surveyorName'>
            {userType == "Admin" && "Me"}
            {userType == "Surveyor" && record?.adminDetails?.fullName}
          </span>
          <span className='surveyorEmail'>
            {userType == "Admin" && "Me"}
            {userType == "Surveyor" && record?.adminDetails?.email}
          </span>
        </div>
      ),
    },
    {
      title: "Form Link",
      width: "5.66%",
      render: (text, record) => (
        <Popover content={<div>Preview form</div>} trigger='hover'>
          <Link
            // to={record?.id + "/questions"}
            to={"/forms/" + EncodeURL(record?._id)}
            target='_blank'
            className='formLink'
            // onClick={(e) => {
            //   // e.preventDefault();
            //   updateCurrentForm(record);
            // }}
          >
            <FaLink />
            {/* forms.sde/{record?._id} */}
          </Link>
        </Popover>
      ),
    },
    {
      title: "Form Type",
      dataIndex: "formType",
      key: "formType",
      width: "8.66%",
      render: (text, record) => <span className='formType'>{text}</span>,
    },
    {
      title: "Visibility",
      dataIndex: ["formMetadata", "visibility"],
      key: ["formMetadata", "visibility"],
      width: "10%",
      render: (text, record) => (
        <span
          className={
            "formType px-3  btn rounded-pill fw-bold text-sm " +
            (text == "PUBLIC" ? "public btn-success " : "private btn-warning")
          }
          style={{
            fontSize: "14px",
          }}
        >
          {text}
        </span>
      ),
    },
    // {
    //   title: "Mobile Number",

    //   width: "12.66%",
    //   render: (text, record) => (
    //     <span className='form'>
    //       {userType == "Admin" &&
    //         record?.adminDetails?.phone &&
    //         maskPhoneNumber(record?.adminDetails?.phone)}
    //       {userType == "Surveyor" &&
    //         record?.surveyorDetails?.phone &&
    //         maskPhoneNumber(record?.surveyorDetails?.phone)}
    //     </span>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "formStatus",
      key: "formStatus",
      width: "10%",
      render: (text, record) => (
        <span
          className={`tablePill statusPill  ${text
            .replace("_", " ")
            .toLowerCase()} `}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Action",
      width: "20%",
      render: (text, record) => (
        <div
          className='tableActionButtonWrapper'
          style={{ justifyContent: "flex-start" }}
          key={record?._id}
        >
          {localStorage.getItem("shub-roles") !== roles.SURVEYOR && (
            <Popover content={<div>Edit form</div>} trigger='hover'>
              <Link
                to={record?._id + "/questions"}
                onClick={(e) => {
                  // e.preventDefault();
                  updateCurrentForm(record);
                }}
                title='Edit the form'
                style={{ width: "30%" }}
              >
                <span className='tableActionButton'>
                  <BiEdit />
                </span>
              </Link>
            </Popover>
          )}
          {localStorage.getItem("shub-roles") === roles.SURVEYOR && (
            <Popover content={<div>View form responses</div>} trigger='hover'>
              <Link
                to={record?._id + "/responses"}
                onClick={(e) => {
                  // e.preventDefault();
                  updateCurrentForm(record);
                }}
                title='View Form Responses'
                style={{
                  width: "30%",
                  fontSize: "25px",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <span className='tableActionButton'>
                  <TbReportAnalytics />
                </span>
              </Link>
            </Popover>
          )}
          <Popover content={<div>Toggle Visibility</div>} trigger='hover'>
            <span
              className=' tableActionButton visibilityToggler'
              onClick={() => toggleVisibility(record)}
              style={{
                width: "30%",
                fontSize: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {allForms?.loading ||
              updatedMetaData?.loading ||
              deletedForm?.loading ? (
                <Loader color='#151515' />
              ) : (
                <>
                  {record?.formMetadata?.visibility !== "PRIVATE" ? (
                    <AiFillEye title='Disable public sharing' />
                  ) : (
                    <AiFillEyeInvisible title='Enable public sharing' />
                  )}
                </>
              )}
            </span>
          </Popover>
          <Popconfirm
            okType='danger'
            title='Delete the form?'
            description='Are you sure to delete thisform?'
            onConfirm={(e) => handleDeleteForm(record?._id)}
            // onCancel={cancel}
            okText='Yes'
            cancelText='No'
          >
            <Popover content={<div>Delete Form</div>} trigger='hover'>
              <span
                className='tableActionButton'
                style={{
                  width: "30%",
                  fontSize: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {deletedForm?.loading ? (
                  <Loader color='#151515' />
                ) : (
                  <FaTrash color='red' size={21} />
                )}
              </span>
            </Popover>
          </Popconfirm>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getForms();
  }, []);
  const updateCurrentForm = (record) => {
    dispatch(setCurrentForm(record));
  };

  const toggleVisibility = (record) => {
    let newVis;
    if (record?.formMetadata?.visibility === "PRIVATE") newVis = "PUBLIC";
    else if (record?.formMetadata?.visibility === "PUBLIC") newVis = "PRIVATE";
    setCurrForm({
      id: record?._id,
      visibility: newVis,
      color: record?.formMetadata?.theme?.color || "#fff",
    });
    // dispatch(toggleFormVisibility(record?.id));
  };

  const handleDeleteForm = (id) => {
    deleteForm({ variables: { deleteFormId: id } });
  };
  useEffect(() => {
    setData(state?.forms);
  }, [state]);

  useEffect(() => {
    if (
      currForm?.id !== "" &&
      currForm?.visibility !== "" &&
      currForm?.color !== ""
    )
      updateFormMetadata();
  }, [currForm]);

  const handleChange = (e) => {
    var value = e.target.value.toLowerCase();

    var searchArray = localForms?.filter(
      (item) =>
        item?.surveyorDetails?.fullName?.toLowerCase()?.includes(value) ||
        item?.surveyorDetails?.email?.toLowerCase()?.includes(value) ||
        item?.surveyorDetails?.phone?.toLowerCase()?.includes(value) ||
        item?.formType?.toLowerCase()?.includes(value) ||
        item?.formTitle?.toLowerCase()?.includes(value)
    );

    if (searchArray.length > 0) {
      setData(searchArray);
    } else if (searchArray.length == 0) {
      setData(localForms);
    }
  };
  return (
    <section className='manageFormWrapper'>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Manage Forms </div>
        <Link to='/dashboard/create-form' className='btn btn-primary'>
          + Create New Form
        </Link>
      </div>
      <div className='sectionContentWrapper'>
        {/* {loading ? (
          <>Loading...</>
        ) : ( */}
        <>
          <div className='sectionHeaderWrapper flex items-center content-between mt-0'>
            <form
              className='searchForm col-md-8'
              onSubmit={(e) => e.preventDefault()}
            >
              <button type='submit'>
                <RiSearchLine />
              </button>
              <input
                type='text'
                placeholder='Search for names, emails, numbers'
                onKeyUp={(e) => handleChange(e)}
              />
            </form>
            <button className='btn btn-primary w-auto' onClick={getForms}>
              {allForms?.loading ||
              updatedMetaData?.loading ||
              deletedForm?.loading ? (
                <Loader color='#fff' />
              ) : (
                <AiOutlineReload />
              )}
            </button>
          </div>
          <AntdTable
            columns={columns}
            dataSource={[...data]?.reverse()}
            scroll={{
              x: "auto",
            }}
            loading={data?.length == 0 && allForms?.loading}
            pagination={{
              defaultCurrent: paginateStatus.current,
              pageSize: PageSize,
            }}
            onChange={(pagination, e) => {
              setPaginateStatus(pagination);
              setPageSize(pagination?.pageSize);
            }}
            sticky
          />
        </>
        {/* )} */}
      </div>
    </section>
  );
};

export default ManageForm;
